// extracted by mini-css-extract-plugin
export var columnItem = "_ed-3";
export var columnItemDraggable = "_ed-4";
export var dragHandle = "_ed-0";
export var dragHandleHovered = "_ed-1";
export var dropdown = "_ed-5";
export var dropdownContent = "_ed-7";
export var dropdownInner = "_ed-6";
export var filterDropdownHeader = "_ed-8";
export var icon = "_ed-2";
export var sectionDivider = "_ed-9";